import { useMutation } from '@apollo/client';
import { UNEXPECTED_ERROR_MESSAGE } from '../constants';
import { ICreateSubscriptionIntentResult } from '@monofront/types';
import { CREATE_INTENT } from '../queries';

export const useGetClientSecret = () => {
  const [retrieveClientSecretRequest] =
    useMutation<ICreateSubscriptionIntentResult>(CREATE_INTENT);

  return (): Promise<string | undefined> =>
    new Promise((resolve, reject) => {
      retrieveClientSecretRequest()
        .then((clientSecretResponse) => {
          const clientSecret =
            clientSecretResponse.data?.createSubscriptionIntent;

          if (!clientSecret) {
            reject({
              errorKey: 'invalid_intent',
              errorMessage: UNEXPECTED_ERROR_MESSAGE,
            });

            return;
          }

          return resolve(clientSecret);
        })
        .catch(reject);
    });
};
